import { render, staticRenderFns } from "./SemesterTypeSelectbox.vue?vue&type=template&id=57bbfda5&"
import script from "./SemesterTypeSelectbox.vue?vue&type=script&lang=js&"
export * from "./SemesterTypeSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports